var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.loading)?_c('div',[_c('app-form',{attrs:{"parentObject":{
        data: this.staffData,
        searchnew: this.search,
        pageTitle: this.pageTitle,
        pageTitleValue: this.pageTitleValue,
        errMsg: this.errMsg,
        isEdit: this.editMode,
        isNewHire: this.isNewHire,
        isLocMov: this.isLocMov,
        isJobMov: this.isJobMov,
        isSalMov: this.isSalMov,
        isContrMov: this.isContrMov,
        isConfirmation: this.isConfirmation,
        isCessation: this.isCessation
      }},on:{"input":function($event){_vm.staffData = $event},"save":_vm.saveHandler,"delete":function($event){_vm.isConfirm = !_vm.isConfirm},"newmovesave":_vm.newMovementHandler,"profile":function($event){_vm.statffData.pic = $event},"pageTitleValue":function($event){_vm.pageTitleValue = $event},"error":_vm.errorHandler}}),(_vm.isErr)?_c('div',[_c('app-error',{attrs:{"parentError":{
          data: this.errMsg,
          isErr: this.isErr,
        }},on:{"closeError":function($event){_vm.isErr = $event}}})],1):_vm._e(),(_vm.isConfirm)?_c('div',[_c('app-confirm',{attrs:{"parentObject":{
          pageTitleValue: this.pageTitleValue,
          isConfirm: this.isConfirm,
        }},on:{"confirm":function($event){return _vm.deleteHandler($event)},"cancelConfirm":function($event){_vm.isConfirm = !_vm.isConfirm}}})],1):_vm._e()],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }